import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

import cheapestIcon from "../assets/cheapest.svg";
import compareIcon from "../assets/compare.svg";
import myListIcon from "../assets/myList.svg";
import pasteListIcon from "../assets/pastelist.svg";

import rect1 from "../assets/sainsburys.svg";
import rect2 from "../assets/tesco.svg";
import rect3 from "../assets/asda.svg";
import rect4 from "../assets/morrisons.svg";

function TickRow({ label }) {
  return (
    <div className="flex items-start gap-3 rounded-xl bg-white px-3 py-3 shadow-sm sm:items-center sm:px-4">
      <span className="inline-flex h-4 w-4 items-center justify-center rounded-[4px] border border-[#D9D9D9] bg-[#D9D9D9]"/>
      <p className="text-[14px] font-medium leading-relaxed text-[#24303A] sm:text-[15px] md:text-[16px]">{label}</p>
    </div>
  );
}

function StepCard({ title, subtitle, bullets }) {
  return (
    <div className="rounded-2xl border border-[#E6EAF0] bg-[#F5F7FB] px-4 py-4 shadow-sm sm:px-5 sm:py-5">
      <h3 className="text-[16px] font-semibold leading-snug text-[#24303A] sm:text-[18px] md:text-[20px]">{title}</h3>
      <p className="mt-2 text-[13px] font-normal leading-relaxed text-[#6E7B86] sm:text-[14px]">{subtitle}</p>
      <div className="mt-4">
        <ul className="mt-2 list-disc space-y-1 bg-white px-2 py-2 pl-5 text-[13px] font-normal text-[#6E7B86] sm:text-[14px]">
          {bullets.map((b) => (
            <li key={b}>{b}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function CoreFeatureCard({ img, title, subtitle }) {
  return (
    <div className="rounded-2xl p-3">
      <div className="rounded-xl">
        <img src={img} alt="" className="h-[110px] w-full rounded-xl object-cover object-center" />
      </div>
      <h3 className="mt-3 text-[15px] font-medium text-[#24303A] sm:text-[16px]">{title}</h3>
      <p className="mt-1 text-[13px] font-normal leading-relaxed text-[#6E7B86] sm:text-[14px]">{subtitle}</p>
    </div>
  );
}

function MiniIconCard({ icon, title, subtitle }) {
  return (
    <div className="rounded-2xl border border-[#E6EAF0] bg-white px-4 py-4 shadow-sm sm:py-5">
      <div className="flex flex-col items-start gap-3">
        <img src={icon} alt="" className="h-8 w-8" />
        <div>
          <h3 className="text-[14px] font-medium leading-relaxed text-[#24303A] sm:text-[16px]">{title}</h3>
          <p className="mt-1 text-[13px] font-normal text-[#6E7B86] sm:text-[14px]">{subtitle}</p>
        </div>
      </div>
    </div>
  );
}

function HowItWorks({ onOpenAuth, onOpenMenu }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F5F7FB] text-[#24303A]">
      <Header onOpenAuth={onOpenAuth} onOpenMenu={onOpenMenu} />

      <main className="mx-auto w-full max-w-[90rem] px-3 py-4 sm:px-4 sm:py-6 md:px-6 md:py-10">
        {/* Hero */}
        <section className="rounded-xl border border-white/20 bg-gradient-to-b from-[#7352C7] to-[#A67FFB] px-4 py-5 text-white shadow-[0_16px_40px_-20px_rgba(123,94,212,0.55)] sm:px-6 sm:py-6 md:rounded-2xl md:px-8 md:py-10">
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div className="max-w-2xl">
              <h1 className="text-[22px] font-bold leading-tight sm:text-[24px] md:text-[28px]">
                Smarter grocery shopping starts here
              </h1>
              <p className="mt-2 text-[14px] font-normal leading-relaxed text-white sm:text-[15px] md:text-[16px]">
                FEMTYZ Helps You Compare Grocery Prices Across Major Supermarkets, Build Smarter Lists,
                Stay On Budget, And See Where Your Money Goes Further.
              </p>
            </div>

            <div className="flex flex-col items-start gap-2 md:items-end">
              <p className="text-[14px] font-semibold tracking-wide text-[#F5F7FB] sm:text-[16px] md:text-[18px]">
                Save Time. Compare Better. Shop Smarter.
              </p>
              <div className="flex flex-wrap items-center gap-2 sm:gap-3">
                <button
                  type="button"
                  onClick={() => navigate("/paste-list")}
                  className="rounded-full border-2 border-white px-4 py-1.5 text-[13px] font-bold text-white sm:px-5 sm:text-[14px] md:text-[16px]"
                >
                  Paste Your List
                </button>
                {/* <button
                  type="button"
                  onClick={() => navigate("/features")}
                  className="rounded-full bg-white px-4 py-1.5 text-[13px] font-bold text-[#7352C7] sm:px-5 sm:text-[14px] md:text-[16px]"
                >
                  Compare Prices
                </button> */}
              </div>
            </div>
          </div>
        </section>

        {/* What FEMTYZ does */}
        <section className="mt-8 px-1 sm:mt-10">
          <div className="grid gap-6 md:grid-cols-[1fr_1fr] md:items-start">
            <div>
              <h2 className="text-[22px] font-semibold text-[#24303A] sm:text-[24px] md:text-[28px]">
                What FEMTYZ Does
              </h2>
              <p className="mt-3 text-[14px] font-normal leading-relaxed text-[#6E7B86] sm:text-[15px] md:text-[16px]">
                FEMTYZ Is A Grocery Comparison Platform Designed To Help You Make Better Shopping
                Decisions Before You Buy.
              </p>
              <p className="mt-3 text-[14px] font-normal leading-relaxed text-[#6E7B86] sm:text-[15px] md:text-[16px]">
                Instead Of Checking Multiple Supermarket Websites One By One, FEMTYZ Brings Your
                Options Into One Place So You Can:
              </p>
              <p className="mt-4 text-[14px] font-normal leading-relaxed text-[#6E7B86] sm:text-[15px] md:text-[16px]">
                Whether You Are Planning A Weekly Family Shop, Checking The Cheapest Place To Buy A
                Few Items, Or Trying To Make Your Budget Stretch Further, FEMTYZ Helps You See The
                Smartest Way To Shop.
              </p>
            </div>

            <div className="space-y-3">
              <TickRow label="Compare Prices Across Stores" />
              <TickRow label="Build And Manage Grocery Lists" />
              <TickRow label="Spot Better-Value Baskets" />
              <TickRow label="Track Savings" />
              <TickRow label="Stay Within Budget" />
              <TickRow label="Switch Between Different Price Views Such As Base Price And Offer + Loyalty" />
            </div>
          </div>
        </section>

      {/* 5 steps */}
        <section className="mt-8 bg-white px-3 pb-6 pt-6 sm:mt-10 sm:px-4 sm:pb-8 sm:pt-8 md:px-6 md:pb-10 md:pt-10">
          <h2 className="pt-2 text-center text-[22px] font-semibold text-[#24303A] sm:text-[24px] md:pt-4 md:text-[28px]">
            How FEMTYZ Works In 5 Steps
          </h2>

          <div className="grid gap-4 py-5 sm:gap-5 sm:py-6 lg:grid-cols-3 lg:gap-6 lg:py-7">
            <StepCard
              title="Search or paste your shopping list"
              subtitle="Start By Searching For A Product Or Pasting A Full Shopping List From WhatsApp, Notes, A Recipe, Or Anywhere Else You Keep Your Items."
              bullets={[
                'Examples Of Inputs',
                'Milk',
                "Bread,milk,eggs",
                "Rice 1kg",
                "A Full Pasted List With One Item Per Line",
              ]}
            />
            <StepCard
              title="Compare prices across supermarkets"
              subtitle="Once Your Items Are Matched, FEMTYZ Shows You How Prices Compare Across Different Retailers."
              bullets={[
                "The Cheapest Retailer For Each Item",
                "The Difference Between The Lowest And Highest Price",
                "Available Offers",
                "Pricing By Mode",
              ]}
            />
            <StepCard
              title="Build your Grocery List"
              subtitle="As You Compare, You Can Add Products To Your Grocery List. Your Shopping Basket Inside FEMTYZ Helps You Organise Items, Adjust Quantities, And See The Financial Impact Of Your Choices Before You Shop."
              bullets={[
                "Rename Lists",
                "Add Or Remove Items",
                "Update Quantities",
                "Compare Totals By Price Mode",
                "Review Savings",
              ]}
            />
          </div>

          <div className="grid gap-4 py-2 sm:gap-5 sm:py-3 lg:grid-cols-3 lg:gap-6 lg:py-4">
            <StepCard
              title="Review your Smart Basket"
              subtitle="FEMTYZ Brings Your Selected Items Together Into A Smarter Summary View So You Can See The Bigger Picture."
              bullets={[
                "Total Basket Value",
                "Cheapest Basket Outcome",
                "Savings Opportunity",
                "How Your Basket Compares Across Retailers",
                "Whether You Are Within Budget Or Over Budget",
              ]}
            />
            <StepCard
              title="Stay in control of your budget"
              subtitle="Budget Is A Core Part Of The FEMTYZ Experience."
              bullets={[
                "What Your Basket Currently Costs",
                "How Much You Are Saving",
                "How Much Budget You Have Left",
                "If You Are Over Budget",
                "Where Cheaper Substitutions May Help",
              ]}
            />
          </div>
        </section>

        {/* Core features */}
        <section className="bg-[#F5F7FB] px-1 pt-8 sm:pt-10">
          <h2 className="text-center text-[22px] font-semibold text-[#24303A] sm:text-[24px] md:text-[28px]">
            Core Features
          </h2>
          <div className="mt-5 grid gap-4 sm:grid-cols-2 md:mt-7 md:gap-6 lg:grid-cols-4">
            <CoreFeatureCard
              img={rect1}
              title="Compare Prices"
              subtitle="See How The Same Or Similar Product Is Priced Across Supermarkets, With The Cheapest Option Clearly Highlighted."
            />
            <CoreFeatureCard
              img={rect2}
              title="Smart Basket"
              subtitle="Get A Basket-Level View Of Savings, Spend, And Value Instead Of Judging Products One At A Time."
            />
            <CoreFeatureCard
              img={rect3}
              title="Grocery Lists"
              subtitle="Create And Manage Your Own Shopping Lists So You Can Plan Shops, Compare Totals, And Organise Recurring Purchases."
            />
            <CoreFeatureCard
              img={rect4}
              title="Paste List"
              subtitle="Quickly Paste Items From Everyday Sources Like WhatsApp, Notes, And Recipes To Save Time And Reduce Manual Entry."
            />
              {/* <CoreFeatureCard
              img={rect1}
              title="Compare Prices"
              subtitle="See How The Same Or Similar Product Is Priced Across Supermarkets, With The Cheapest Option Clearly Highlighted."
            />
            <CoreFeatureCard
              img={rect2}
              title="Smart Basket"
              subtitle="Get A Basket-Level View Of Savings, Spend, And Value Instead Of Judging Products One At A Time."
            /> */}
            {/* <CoreFeatureCard
              img={rect3}
              title="Grocery Lists"
              subtitle="Create And Manage Your Own Shopping Lists So You Can Plan Shops, Compare Totals, And Organise Recurring Purchases."
            /> */}
            {/* <CoreFeatureCard
              img={rect4}
              title="Paste List"
              subtitle="Quickly Paste Items From Everyday Sources Like WhatsApp, Notes, And Recipes To Save Time And Reduce Manual Entry."
            /> */}
          </div>
        </section>

        {/* Why useful */}
        <section className="mt-10 bg-white px-3 pb-6 pt-6 sm:mt-12 sm:px-4 sm:pb-8 sm:pt-8 md:mt-14 md:px-6 md:pb-10 md:pt-10">
          <h2 className="text-center text-[22px] font-semibold text-[#24303A] sm:text-[24px] md:text-[28px]">
            Why FEMTYZ Is Useful
          </h2>
          <p className="mx-auto mt-3 max-w-4xl text-center text-[14px] font-normal leading-relaxed text-[#6E7B86] sm:text-[15px]">
            Start By Searching For A Product Or Pasting A Full Shopping List From WhatsApp, Notes, A
            Recipe, Or Anywhere Else You Keep Your Items. FEMTYZ Reads Your List, Checks The Products
            Available Across Supported Supermarkets, And Prepares Them For Comparison.
          </p>

          <div className="mt-6 grid gap-4 sm:grid-cols-2 md:mt-8 md:gap-5 lg:grid-cols-5">
            <MiniIconCard
              icon={cheapestIcon}
              title="Households Trying To Reduce Recurring Weekly Costs"
              subtitle=""
            />
            <MiniIconCard
              icon={myListIcon}
              title="Families Managing Larger Recurring Grocery Lists"
              subtitle=""
            />
            <MiniIconCard
              icon={compareIcon}
              title="Users Comparing Offers Across More Than One Store"
              subtitle=""
            />
            <MiniIconCard
              icon={pasteListIcon}
              title="Shoppers Who Want Quicker Visibility Into Value"
              subtitle=""
            />
            <MiniIconCard
              icon={cheapestIcon}
              title="Budget-Conscious Subscribers Who Want Smarter Decisions, Not More Scrolling"
              subtitle=""
            />
          </div>
        </section>

        {/* What makes different */}
        <section className="mt-10 px-1 pb-4 sm:mt-12 md:mt-14 md:pb-8">
          <div className="grid gap-6 md:grid-cols-[1.2fr_1fr] md:items-start">
            <div>
              <h2 className="text-[22px] font-semibold text-[#24303A] sm:text-[24px] md:text-[28px]">
                What Makes FEMTYZ Different
              </h2>
              <p className="mt-3 text-[14px] font-normal leading-relaxed text-[#6E7B86] sm:text-[15px] md:text-[16px]">
                Start By Searching For A Product Or Pasting A Full Shopping List From WhatsApp, Notes,
                A Recipe, Or Anywhere Else You Keep Your Items.
              </p>
              <p className="mt-3 text-[14px] font-normal leading-relaxed text-[#6E7B86] sm:text-[15px] md:text-[16px]">
                FEMTYZ Reads Your List, Checks The Products Available Across Supported Supermarkets,
                And Prepares Them For Comparison.
              </p>
              <p className="mt-4 text-[14px] font-normal leading-relaxed text-[#6E7B86] sm:text-[15px] md:text-[16px]">
                That Means The Platform Is Built To Help You Answer Questions Like:
              </p>
            </div>

            <div className="">
              <TickRow label="Where Is This Item Cheapest Today?" />
              <TickRow label="Which Shop Gives Me The Best Overall Basket?" />
              <TickRow label="How Much Am I Saving?" />
              <TickRow label="Am I Within Budget?" />
              <TickRow label="Would Switching A Few Items Improve My Total?" />
              <p className="pt-4 text-[14px] font-normal leading-relaxed text-[#6E7B86] sm:pt-6 sm:text-[15px]">
                This Is Why FEMTYZ Is Best Understood As Fintech For Groceries.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default HowItWorks;

